import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { CustomSpinner } from './Spinner.tsx';

export function LoadingButton(
  props: Readonly<{
    type: string;
    text: string;
    imagePath: string | null;
    loading: boolean;
    onClick: undefined | (() => void) | ((e: never) => void);
    disabled?: boolean;
  }>,
) {
  return (
    <Button
      type={'submit'}
      className={`${props.type}`}
      disabled={props.loading || props.disabled}
      onClick={props.onClick}>
      {props.loading ? (
        <CustomSpinner class={'d-flex justify-content-center'} size={'sm'} />
      ) : (
        <p className={'my-auto'}>
          {props.imagePath ? (
            <>
              <img src={props.imagePath} width="25" height="25" alt={'img'} />
              <span className={'ms-1'}>{props.text}</span>
            </>
          ) : (
            <span>{props.text}</span>
          )}
        </p>
      )}
    </Button>
  );
}

export function RoundedButton(
  props: Readonly<{
    type: string;
    text: string;
    imagePath: string | null;
    loading: boolean;
    onClick: undefined | (() => void);
  }>,
) {
  return (
    <Button type={'submit'} className={`${props.type}`} disabled={props.loading} onClick={props.onClick}>
      {props.loading ? (
        <CustomSpinner class={'d-flex justify-content-center'} />
      ) : (
        <p>
          {props.imagePath ? (
            <>
              <img src={props.imagePath} width="5" height="5" alt={'img'} />
              <span className={'ms-1'}>{props.text}</span>
            </>
          ) : (
            <span>{props.text}</span>
          )}
        </p>
      )}
    </Button>
  );
}

export function Backlink(
  props: Readonly<{
    text: string;
    to: string;
    style: string;
  }>,
) {
  return (
    <Link className={props.style} to={props.to}>
      <span className={'ms-1 my-auto'}>{props.text}</span>
    </Link>
  );
}

export function TextButton(
  props: Readonly<{
    text: string;
    onClick: () => void;
    style?: string;
  }>,
) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={`btn btn-link p-0 m-0 ${props.style}`}
      style={{ textDecoration: 'none', color: 'inherit' }}>
      <span className="ms-1 card-text">{props.text}</span>
    </button>
  );
}

export function EyeButton(
  props: Readonly<{
    show: boolean;
    onClick: () => void;
  }>,
) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={`btn btn-link p-0 m-0`}
      style={{ textDecoration: 'none', color: 'inherit' }}>
      {props.show ? <EyeOutlined /> : <EyeInvisibleOutlined />}
    </button>
  );
}

export function IconButton(
  props: Readonly<{
    imagePath: string;
    onClick: () => void;
    alt: string;
    size?: number;
    style?: string;
  }>,
) {
  return (
    <img
      src={props.imagePath}
      width={props.size || 18}
      height={props.size || 18}
      alt={props.alt}
      onClick={props.onClick}
      className={`ariane btn btn-link p-0 m-0 w-full h-full ${props.style}`}
    />
  );
}
